import React, { useState } from 'react';
import { Alert, Overlay } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import CloseIcon from '@material-ui/icons/Close';
import { FlagContentMessage } from './FlagContentMessage';
import { reportCandidateContent } from '../../../../api/SlmService';
import { Spinner } from '../../../common/Spinner/Spinner';
import { generateImageSource } from '../../../../utils/generateImageSource';

const PROFILE_SECTIONS = ['About me', 'Work experience', 'Portfolio', 'Other'];

export const FlagContent = ({ candidate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [displayModal, setModalState] = useState(false);
  const [showCompletionMessage, setShowCompletionMessage] = useState(false);

  const toolTipContent = 'Select this link if you find inappropriate content on a candidate profile.  This action will notify The Home Depot to review the candidate’s profile.';

  // opens modal
  function openModal() {
    setModalState(true);
    openModal;
  }

  // closes modal
  function closeModal(e) {
    e.stopPropagation();
    setModalState(false);
    setShowCompletionMessage(false);
  }

  // send info to api and move to confirmation screen
  async function reportProfile() {
    setIsLoading(true);
    try {
      await reportCandidateContent(candidate.candidateId, candidate.name, 'User\'s profile');
      setShowCompletionMessage(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="flag-content__wrapper">
      <Tooltip channel="desktop" content={toolTipContent} className="flag-content__tool-tip">
        <img className="flag-content__tool-tip-icon" src={generateImageSource('/images/v1/info.svg')} />
      </Tooltip>
      <span data-testid="open-report-modal" onClick={openModal}>Report</span>
      <p>
        {' '}this profile for inappropriate content and/or behavior
      </p>

      {showCompletionMessage ? (
        <Alert
          data-testid="report-profile-success-alert"
          type="success"
          title="Profile Reported: "
          message="Thank you for helping to maintain our community "
        />
      ) : (
        <Overlay
          modalClass="p2p-overlay flag-content__modal"
          onClose={closeModal}
          open={displayModal}
        >
          <button
            tabIndex={-1}
            aria-label="close"
            className="p2p-portfolio__overlay-close-button"
            data-testid="report-overlay-close-button"
            onClick={closeModal}
          >
            <CloseIcon style={{ fontSize: '3rem' }} />
          </button>
          <FlagContentMessage
            closeModal={closeModal}
            reportProfile={reportProfile}
            profileSections={PROFILE_SECTIONS}
          />
        </Overlay>
      )}

    </div>
  );
};

FlagContent.propTypes = {
  candidate: PropTypes.shape({
    candidateId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};
